var map = {
	"./Avatar_1.png": 7396,
	"./Avatar_10.png": 5415,
	"./Avatar_11.png": 1510,
	"./Avatar_12.png": 6753,
	"./Avatar_13.png": 672,
	"./Avatar_14.png": 5934,
	"./Avatar_15.png": 4985,
	"./Avatar_16.png": 2258,
	"./Avatar_17.png": 1017,
	"./Avatar_18.png": 610,
	"./Avatar_19.png": 7530,
	"./Avatar_2.png": 2956,
	"./Avatar_20.png": 4792,
	"./Avatar_21.png": 4138,
	"./Avatar_22.png": 5949,
	"./Avatar_23.png": 808,
	"./Avatar_24.png": 2377,
	"./Avatar_3.png": 3709,
	"./Avatar_4.png": 7538,
	"./Avatar_5.png": 3477,
	"./Avatar_6.png": 4873,
	"./Avatar_7.png": 8193,
	"./Avatar_8.png": 7855,
	"./Avatar_9.png": 5141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5032;